import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const ITEMS = [
  {
    q: "Est-ce que je dois tout vous expliquer depuis le début ?",
    a: "Non. On commence par un appel de 30 minutes. Ensuite on travaille avec ce que vous nous envoyez — un message vocal, une photo d'un document, un email. Pas besoin d'être organisé pour commencer.",
  },
  {
    q: "Comment transmettez-vous mes devis à mes clients ?",
    a: "Selon votre préférence : par email depuis votre adresse, par votre outil habituel (Batiprix, Devis & Factures, autre), ou via un modèle qu'on crée ensemble. On s'adapte à votre façon de travailler.",
  },
  {
    q: "Que se passe-t-il si je veux arrêter ?",
    a: "Vous prévenez 15 jours avant. Pas de frais, pas de justification à donner. On vous restitue tous vos documents.",
  },
  {
    q: "Vous travaillez avec tous les corps de métier ?",
    a: "Oui — plombiers, électriciens, peintres, maçons, carreleurs, menuisiers, couvreurs, et plus encore. Du moment que vous avez des devis à rédiger et des clients à facturer, on peut vous aider.",
  },
  {
    q: "Je suis auto-entrepreneur, est-ce que c'est déductible pour moi aussi ?",
    a: "La déduction fiscale s'applique principalement aux artisans imposés au réel (BIC). Si vous êtes au micro-BIC avec l'abattement forfaitaire, le mécanisme est différent. Nous vous conseillons de vérifier avec votre comptable.",
  },
  {
    q: "Vous avez accès à mes données bancaires ou comptables ?",
    a: "Non. Nous gérons vos documents administratifs et commerciaux (devis, factures, courriers). Vos données bancaires et votre comptabilité restent chez votre comptable.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-[#F5F0EB] py-20 sm:py-28 lg:py-32"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="reveal">
          <span className="inline-block text-[#E8611A] font-semibold text-sm tracking-widest uppercase mb-4">
            FAQ
          </span>
          <h2 className="font-display font-extrabold text-[#1A2E4A] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Vos questions
          </h2>
        </div>

        <div className="mt-12 sm:mt-16 reveal">
          <Accordion
            type="single"
            collapsible
            className="bg-white border border-black/5 rounded-sm divide-y divide-black/5"
            data-testid="faq-accordion"
          >
            {ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b-0 px-5 sm:px-7"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-display font-bold text-[#1A2E4A] text-base sm:text-lg py-5 sm:py-6 hover:no-underline hover:text-[#E8611A] transition-colors text-left"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-[#2D2D2D]/80 text-sm sm:text-base leading-relaxed pb-5 sm:pb-6 pr-4"
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
